async function fetchDownloads(url) {
    try {
        const response = await fetch(url, {
         method: 'GET',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
            },
      });
        if (!response.ok) {
            throw Error(response.statusText);
        }
        return await response.json();
    } catch (error) {
        console.error(error);
        return [];
    }
  }
  
export default () => ({
    years: [],
    downloads: [],
    showVideoModal: false,
    embedUrl: '',
  
    async init() {
        try {
            const yearsData = await fetchDownloads('/wp-json/download/v1/resultsandreports-years');
            this.years = yearsData.map((post) => ({ year: post.year }));

            //get the first year only
            this.downloads = await fetchDownloads(`/wp-json/download/v1/resultsandreports/${this.years[0].year}`);

        } catch (error) {
            console.error(error);
        }
    },
  
    async changeYear(event) {
        const year = event.target.value;
        try {
            this.downloads = await fetchDownloads(`/wp-json/download/v1/resultsandreports/${year}`);
        } catch (error) {
        console.error(error);
        }
    },
  });
